import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import { useHistory } from "react-router";
import { fetchAppliedCompoffs, fetchCompOffSettings, fetchInitializedCompOffs, selectAppliedCompOffRequests, selectConfigurationSettings, selectManageCompOffRequests } from "../../Redux/Slices/CompOffSlice";
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../managers/TableManger";
import Utility, { deepClone, removeDelayedLoader, showDelayedLoader } from "../../utility/Utility";
import TenantManager from "../../managers/TenantManager";
import { CompOffRequestColumnConfig, parseColumnConfig } from "../configs/config";
import { DKIcons, DKFilterPopup, DKButton, DKIcon, DKLabel, Toggle, DKSpinner, removeLoader, DKListPicker, showLoader, TOAST_TYPE, showToast, showAlert } from "deskera-ui-library";
import { isMobileWebView } from "../../utility/ViewportSizeUtils";
import DataGridHolderPayroll from "../common/DataGridHolderPayroll";
import { COMP_OFF_REQUEST_FILTER } from "./CompOffConstants";
import { CompoffService } from "../../services/CompOffService";
import { saveAs } from 'file-saver';
import AttachmentService from "../../services/AttachmentService";
import { getFileName } from "../configs/config";
import zeroState from "../../assets/images/zero-state-default.svg";
import { MODULE } from "../user-permissions/PermissionUtils";



const ManageCompOffRequest = (props) => {

    const initialState = {
        columnData: [],
        rowData: [],
        originalData: [],
        filter: []
    };

    const history = useHistory();
    const { t } = useTranslation();

    /**Hooks */
    const [compOffRequestsData, setCompOffRequestsData] = useState(initialState);
    const [filterArray, setFilterArray] = useState([]);
    const [tenantDetails, setTenantDetails] = useState(TenantManager.getTenantDetails);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [totalCount, setTotalCount] = useState(10);
    const [filterPopupEnabled, setFilterPopupState] = useState(false);
    const [additionalFilterConditions, setAdditionalFilterConditions] = useState([]);
    const [isFilterEnabled, setIsFilterEnabled] = useState(false);
    const [isLoading, setLoadingFlag] = useState(true);
    const [compOffFilters, setCompOffFilters] = useState(COMP_OFF_REQUEST_FILTER);
    const [selectedEmployeeFilter, setSelectedEmployeeFilter] = useState(COMP_OFF_REQUEST_FILTER[0]);
    const [needSegmentListPicker, setSegmentListPicker] = useState(false);
    const [conditionFilter, setConditionFilter] = useState([]);
    const [searchFilter, setSearchFilter] = useState([]);
    const [prevSearch, setPrevSearch] = useState("");
    const [reload, setReload] = useState(false);


    /**Selectors */
    const compOffRequestsGridData = useSelector(selectAppliedCompOffRequests);

    const configurationSetting = useSelector(selectConfigurationSettings);

    /**Dispatch */
    const dispatch = useDispatch();

    useEffect(() => {
        loadConfigurationSettings()

        window.downloadCompOffFile = (url) => {
            const path = Utility.decodeJSON(url)
            downloadDocument(path);
        }
        return () => {
            window.downloadCompOffFile = null;
            setCurrentPage(1)
        }
    }, [])

    useEffect(() => {

        if (!configurationSetting.isCompOffEnabled) {
            return
        }

        setLoadingFlag(true);
        RouteManager.setPresenter({ props: { ...props, history: history } })
        setCurrentPage(1)
        loadAllEmployeeCompOffs({
            sort_order: "",
            sort_field: "",
            page: 1,
            limit: pageSize,
            search_string: "",
            search_field: "",
            module: "request",
            condition: []
        })
    }, [configurationSetting])



    useEffect(() => {
        if (!Utility.isEmptyObject(compOffRequestsGridData)) {
            setLoadingFlag(true);
            const compOffRequests = compOffRequestsGridData?.data || [];
            const { tenant } = TenantManager.getPeopleTenantData();
            const functionConfig = getFunctionConfig();
            const rowData = CompOffRequestColumnConfig(compOffRequests, functionConfig);
            let columnConfig = parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_MANAGE_COMP_OFF_REQUESTS), TABLES.PEOPLE_MANAGE_COMP_OFF_REQUESTS);

            const passingData = {
                columnData: deepClone(columnConfig),
                rowData,
                filter: [],
                originalData: compOffRequests
            };
            setCompOffRequestsData(passingData);
            setTotalPageCount(compOffRequestsGridData.totalPages);
            setCurrentPage(currentPage);
            setTotalCount(compOffRequestsGridData.numberOfRecords);
            setLoadingFlag(false);

        } else {
            const rowData = [];
            let columns = parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_MANAGE_COMP_OFF_REQUESTS), TABLES.PEOPLE_MANAGE_COMP_OFF_REQUESTS);
            const passingData = {
                columnData: deepClone(columns),
                rowData,
                filter: [],
                originalData: []
            };
            setCompOffRequestsData(passingData);
            setLoadingFlag(false);
        }
    }, [compOffRequestsGridData, reload]);


    const loadConfigurationSettings = async () => {
        try {
            await dispatch(fetchCompOffSettings());
        } catch (err) {

        }
    }

    const loadAllEmployeeCompOffs = async (config) => {
        const timeOut = showDelayedLoader()
        try {
            
            CompoffService.requestCompoffApiConfig = config;
            await dispatch(fetchAppliedCompoffs())
        } catch (err) {

        }
        removeDelayedLoader(timeOut)
    }

    const downloadDocument = (path) => {
        showLoader("Downloading document... Please wait");
        AttachmentService.getPresignedURL(path).then(
            (response) => {
                AttachmentService.downloadFile(response).then(
                    (response) => {
                        removeLoader();
                        saveAs(response, getFileName(path));
                    },
                    (error) => {
                        removeLoader();
                    }
                );
            },
            (error) => {
                removeLoader();
                showToast("Something went wrong", TOAST_TYPE.FAILURE);
            }
        );
    }

    const onStatusUpdate = (employeeCompOff, status) => {

        const paramters = {
            employeeCompOff,
            "status": status

        }
        showLoader(t("COMP_OFF_REQUEST_UPDATE_IN_PROGRESS"))
        CompoffService.updateEmployeeCompOffStatus(paramters).then((response) => {
            showToast(t("COMP_OFF_REQUEST_UPDATE_SUCCESS"), TOAST_TYPE.SUCCESS);
            loadAllEmployeeCompOffs({
                sort_order: "",
                sort_field: "",
                page: currentPage,
                limit: 20,
                search_string: "",
                search_field: "",
                module: "request",
                condition: []
            })
            removeLoader();
        }, (err) => {
            showToast(t("SOMETHING_WENT_WRONG"), TOAST_TYPE.ERROR);
            removeLoader();
        })
    }

    const getFunctionConfig = () => {
        let config = {
            "onApprove": onApproveCompOff,
            "onReject": onRejectCompOff,
            "onDelete": onDeleteCompOffRequest,
        };
        return config;
    }

    const onFilter = (updatedList, queries) => {

        const statusValues = []
        queries?.forEach((c) => {
            if (c.value[0] != "all") {
                let group = {
                    colId: 'status',
                    value: c.value[0]
                }
                statusValues.push(group)
            }
        });

        if (searchFilter.length > 0) {
            statusValues.push(searchFilter[0])
        }
        setCurrentPage(1);
        loadAllEmployeeCompOffs({
            sort_order: "",
            sort_field: "",
            page: 1,
            limit: pageSize,
            search_string: "",
            search_field: "",
            module: "request",
            condition: statusValues
        })

    };

    const onApproveCompOff = (data) => {
        console.log(data)

        var employeeCompOffData = data.rowData.employeeCompOff
        var employeeCompOff = deepClone(employeeCompOffData)
        employeeCompOff["status"] = "APPROVED"
        employeeCompOff["approvedDays"] = employeeCompOff["approvedDays"] + data.rowData.duration
        employeeCompOff["appliedDays"] = employeeCompOff["appliedDays"] - data.rowData.duration
        onStatusUpdate([employeeCompOff], "APPROVED")

    }

    const onRejectCompOff = (data) => {
        console.log(data)

        var employeeCompOffData = data.rowData.employeeCompOff
        var employeeCompOff = deepClone(employeeCompOffData)
        employeeCompOff["status"] = "REJECTED"
        employeeCompOff["rejectedDays"] = employeeCompOff["rejectedDays"] + data.rowData.duration
        employeeCompOff["appliedDays"] = employeeCompOff["appliedDays"] - data.rowData.duration
        onStatusUpdate([employeeCompOff], "REJECTED")
    }

    const onDeleteCompOffRequest = (data) => {

        const params = data.rowData?.employeeCompOff
        showLoader(t("COMP_OFF_REQUEST_DELETE_IN_PROGRESS"))
        CompoffService.deleteRequestCompoffs([params]).then((response) => {
            showToast(t("COMP_OFF_REQUEST_DELETE_SUCCESS"), TOAST_TYPE.SUCCESS);
            setCurrentPage(1);
            loadAllEmployeeCompOffs({
                sort_order: "",
                sort_field: "",
                page: 1,
                limit: 20,
                search_string: "",
                search_field: "",
                module: "request",
                condition: []
            })
            removeLoader();
        }, (err) => {
            removeLoader();
            showToast(t("SOMETHING_WENT_WRONG"), TOAST_TYPE.ERROR);
        })
    }

    const onSearch = (data) => {
        if (data.trim() === "" && prevSearch === "") {
            return
        }

        var values = []

        var data = {
            "colId": "name",
            "key": "userSearch",
            "opr": "c",
            "value": data
        }

        values.push(data)
        setSearchFilter(values)

        if (conditionFilter.length > 0) {
            values.push(conditionFilter[0])
        }

        setPrevSearch(data)
        setCurrentPage(1)
        loadAllEmployeeCompOffs({
            sort_order: "",
            sort_field: "",
            page: 1,
            limit: pageSize,
            search_string: "",
            search_field: "",
            module: "request",
            condition: values
        })
    }

    const nevigateToSetting = () => {
        RouteManager.navigateToPage(PAGE_ROUTES.COMP_OFF.CONFIGURE_COMP_OFF)
    }

    return (
        <>
            {!configurationSetting.isCompOffEnabled ? (
                <div className="d-flex justify-content-center parent-width parent-height">
                    <div className="row" style={{ width: "60%" }}>
                        <div className="bg-white p-h-xl pt-r pb-l border-m border-radius-m border-box dashboard-card column align-items-center parent-width">
                            <div>
                                <img className="ic-xxl pt-xxl" src= {zeroState}>
                                </img>
                            </div>
                            <div className="fw-b fs-xl pt-xl">
                                It seems comp-off isn't enabled yet, Please enable to Manage requests!
                            </div>
                            <div className="d-flex fs-m fw-r pt-l">
                                <div className="text-app cursor-hand" onClick={nevigateToSetting}>
                                    <u>Click here</u>&nbsp;
                                </div>
                                <div>
                                     to enable
                                </div>
                            </div>

                        </div>
                    </div>
                </div>


            ) :

                (<div className="column parent-width flex-1">
                    <div className="column parent-width mb-s position-relative flex-1">
                        <DataGridHolderPayroll
                            tableName={TABLES.PEOPLE_MANAGE_COMP_OFF_REQUESTS}
                            displayTableName={TABLE_DISPLAY_NAME[TABLES.PEOPLE_MANAGE_COMP_OFF_REQUESTS]}
                            allowColumnEdit={false}
                            allowColumnDelete={false}
                            allowColumnShift={false}
                            allowSearch={true}
                            allowFilter={true}
                            allowColumnAdd={false}
                            onRowDelete={onDeleteCompOffRequest}
                            onRowEdit={(data) => {
                            }}
                            onCancelContext={() => {
                            }}
                            addButtonConfig={[]}

                            allowDataExport={false}
                            gridData={compOffRequestsData}
                            onSearch={onSearch}
                            onFilter={onFilter}
                            filter={filterArray}
                            onPaginationClick={(requestedPageNumber) => {
                                const config = {
                                    ...CompoffService.requestCompoffApiConfig,
                                    page: requestedPageNumber,
                                    limit: pageSize,
                                };
                                setCurrentPage(requestedPageNumber)
                                loadAllEmployeeCompOffs(config);
                            }}
                            currentPage={currentPage}
                            totalPageCount={totalPageCount}
                            isActionEnabled={true}
                            contextMenu={true}
                            isMenuVisible={false}
                            allowRowEdit={false}
                            showContextEdit={false}
                            onColumnShift={(data)=> setReload(!reload)}
                            module={MODULE.MANAGE_COMP_OFF_REQUEST}
                        />
                    </div>
                </div>)
            }
        </>
    )

}

export default ManageCompOffRequest;